import { css } from "@emotion/react";

export const Trademark = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 16px 32px;
      gap: 12px;
    `}
  >
    Compass® is a registered trademark.
  </div>
);
